import React, { useMemo, useState } from 'react';
import { Input, Icon } from '@iq/react-components';

const TextWidget = (properties) => {
  const {
    value,
    disabled,
    required,
    onChange,
    schema: {
      default: defaultValue,
      readonly,
      required: customRequired,
      placeholder,
      type,
      inputType,
      min,
      max,
      editable = true,
    },
  } = properties;
  const BASE_TYPES = { string: 'text', number: 'number', color: 'color' };
  const input = inputType || BASE_TYPES[type] || 'text';
  const isPassword = input === 'password';
  const [dirty, setDirty] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const theValue = useMemo(() => {
    const defaultValue_ = !defaultValue && defaultValue !== 0 ? '' : defaultValue;
    const useDefault = !value && value !== 0 && !dirty;
    const preCheckedValue = useDefault ? defaultValue_ : value;
    return preCheckedValue || preCheckedValue === 0 ? preCheckedValue : '';
  }, [value, dirty]);

  const handleOnChange = (event) => {
    setDirty(true);
    onChange(event.target.value.trim().length === 0 ? undefined : event.target.value);
  };

  return (
    <>
      {editable ? (
        <div className={isPassword ? 'password-widget' : undefined}>
          <Input
            key={`unique_text_key`}
            required={required || customRequired}
            disabled={disabled}
            readOnly={readonly}
            placeholder={placeholder}
            type={isPassword && !showPassword ? 'password' : input === 'password' ? 'text' : input}
            step={type === 'number' ? 'any' : undefined}
            value={theValue}
            onChange={handleOnChange}
            min={min}
            max={max}
          />
          {isPassword && theValue && (
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Hide' : 'Show'}
            >
              <Icon icon={showPassword ? 'he-preview-off' : 'he-preview'} />
            </button>
          )}
        </div>
      ) : (
        <div className="view-widget">{isPassword && theValue ? '••••••••' : `${theValue}`}</div>
      )}
    </>
  );
};

export default TextWidget;
